import { Auth } from 'aws-amplify'
import {
  MODULE_NAME as AUTH_MODULE,
  CHECK_LOGGED_IN
} from '@/global/auth/store/types'
import { dispatch } from '@/config/store/store'

export async function isLoggedIn(): Promise<boolean> {
  return Auth.currentAuthenticatedUser()
    .then(() => true)
    .catch(() => false)
}

export const addCheckLoginListener = function() {
  document.addEventListener(
    'visibilitychange',
    async () => {
      if (!document.hidden) {
        await isLoggedIn()
      }
    },
    false
  )
}

export const getUser = function() {
  return Auth.currentAuthenticatedUser()
    .then(user => {
      if (!user) {
        return null
      }
      return user
    })
    .catch(e => new Error(e))
}
